import { render, staticRenderFns } from "./uploader.vue?vue&type=template&id=4edd3a87&scoped=true&"
import script from "./uploader.vue?vue&type=script&lang=js&"
export * from "./uploader.vue?vue&type=script&lang=js&"
import style0 from "./uploader.vue?vue&type=style&index=0&id=4edd3a87&lang=scss&scoped=true&"
import style1 from "./uploader.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edd3a87",
  null
  
)

export default component.exports